<template>
  <base-button
    v-if="showCTAButton"
    class="main-header__button"
    :class="{
      'main-header__button--label': ctaLabel,
    }"
    :variant="jssStore.brandName !== 'PubPartners' ? 'secondary' : 'primary'"
    type="link"
    data-booking-block
    :link="ctaHeaderLink?.value"
    :label="ctaLabel"
    :aria-label="ctaLabel"
    :data-cta-text-short="t('header-cta-text-short')"
    :data-cta-text-long="t('header-cta-text-long')"
    data-test-id="header-cta-single-button"
    :tabindex="ctaButtonTabIndex"
    @click="handleBookingClick(ctaLabel)"
  />
  <booking-menu
    v-else-if="bookingOptionsLength > 0"
    ref="bookingMenuRef"
    :booking-options="bookingOptions"
    :booking-options-length="bookingOptionsLength"
    :handle-booking-click="handleBookingClick"
    :cta-button-tab-index="ctaButtonTabIndex"
  />
</template>

<script setup lang="ts">
import { computed, ref, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import BookingMenu from './BookingMenu/BookingMenu.vue';
import BaseButton from '../2_elements/BaseButton/BaseButton.vue';
import useMedia from '../../utils/useMedia';
import { useJssStore } from '../../stores/jssStore';
import type { DataLayerFunctions, BookingOptions } from './types';
import type { LinkField } from '@/types';

const { t } = useI18n();
const { isMedia: isDesktop } = useMedia('(min-width: 1024px)');
const jssStore = useJssStore();

const { handleBookingClick } = inject('dataLayerFunctions') as DataLayerFunctions;

interface HeaderCtaProps {
  ctaHeaderLink?: LinkField;
  ctaButtonTabIndex?: number | null;
  bookingOptions?: BookingOptions;
  overwriteLabel?: boolean;
}

const props = withDefaults(defineProps<HeaderCtaProps>(), {
  ctaHeaderLink: () => ({}) as LinkField,
  bookingOptions: () => ({}) as BookingOptions,
  overwriteLabel: false,
});

const showCTAButton = computed(() => props.ctaHeaderLink?.value?.href);

const bookingOptionsLength = computed(() => Object.keys(props.bookingOptions).length);

const ctaLabel = computed(() => {
  if ((props.overwriteLabel || jssStore.isBookingAppPage) && props.ctaHeaderLink?.value?.text) {
    return props.ctaHeaderLink.value.text;
  }
  return isDesktop ? t('header-cta-text-long') : t('header-cta-text-short');
});

const bookingMenuRef = ref<InstanceType<typeof BookingMenu> | null>(null);

const closeBookingMenu = () => {
  bookingMenuRef.value?.closeMenu();
};

defineExpose({ closeBookingMenu });
</script>
